import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../../Navigation/NavigationContainer';
import Validation from '../../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../../AdvWorkflowStep/AdvWorkflowStepContainer';
import AdvForm from '../../../../CommonComponents/AdvForm';
import { inputTextChanged } from '../../../../Profile/Accounts_react/AccountsUtils';
import Input from '../../../Input/InputView';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../HomePurchaseWorkflowConstants';

const validator = (propertyName, homePurchaseGoals, goalId) => () => {
  if (!propertyName || propertyName.length === 0) {
    return ['Please specify a property name.'];
  }

  if (
    homePurchaseGoals &&
    homePurchaseGoals.filter(({ Id }) => Id !== goalId).some(({ Name }) => Name === propertyName)
  ) {
    return ['This goal already exists. Please enter a unique name.'];
  }

  return [];
};

const PropertyName = ({
  workflowId,
  branch,
  clientId,
  store,
  goal,
  homePurchaseGoals,
  doNotSave,
}) => (
  <AdvWorkflowStep branch={branch} workflowId={workflowId}>
    <Validation workflowId={workflowId} validationId={`${HOME_PURCHASE_GOAL_GRAPH_NODE}.Name`} />

    <h2>What is the name of this property?</h2>

    <AdvForm>
      <ul className="horizontal">
        <li>
          <Input
            isUnder
            type="text"
            id="adv-property-name"
            placeholder="Property name"
            className="md text-center"
            value={goal.Name}
            onChange={inputTextChanged(
              clientId,
              store(workflowId),
              `${HOME_PURCHASE_GOAL_GRAPH_NODE}.Name`,
            )}
          />
        </li>
      </ul>
    </AdvForm>

    <Navigation
      nextIterators={[]}
      dirtyGraphNodes={[]}
      validator={validator(goal.Name, homePurchaseGoals, goal.Id)}
      validationId={`${HOME_PURCHASE_GOAL_GRAPH_NODE}.Name`}
      workflowId={workflowId}
      backendKey={HOME_PURCHASE_GOAL_GRAPH_NODE}
      doNotSave={doNotSave}
    />
  </AdvWorkflowStep>
);

PropertyName.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired,
  store: PropTypes.func.isRequired,
  goal: PropTypes.shape({
    Id: PropTypes.string,
    Name: PropTypes.string,
  }).isRequired,
  homePurchaseGoals: PropTypes.arrayOf(
    PropTypes.shape({
      Name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  doNotSave: PropTypes.bool.isRequired,
};

export default PropertyName;
